import { useQuery } from "@tanstack/react-query";
import React from "react";
import { pageDetails } from "../../services/postService";

function About() {
  const slug = "about-1771581802890";

  const { data, isLoading, error } = useQuery({
    queryKey: ["about-page", slug],
    queryFn: () => pageDetails({ slug }),
    select: (res) => res?.data,
  });

  if (isLoading)
    return (
      <div className="px-6 sm:px-12 h-full flex items-center justify-center py-20">
        <div className="text-gray-400 animate-pulse">Loading content...</div>
      </div>
    );

  if (error || !data)
    return (
      <div className="px-6 sm:px-12 h-full flex items-center justify-center py-20">
        <div className="text-red-400">Failed to load content.</div>
      </div>
    );

  const title = data?.content?.en?.title;
  const content = data?.content?.en?.content;

  return (
    <div className="py-12 sm:py-24 px-6 sm:px-12 bg-gradient-to-b from-[#0f172a] to-[#111827] min-h-screen">
      <div className="max-w-4xl mx-auto space-y-10">
        {/* Page Header */}
        <div className="space-y-4 text-center">
          <h1 className="text-3xl sm:text-4xl font-bold text-white">{title}</h1>
          <div className="w-20 h-1 bg-primary mx-auto rounded-full"></div>
        </div>

        {/* Page Content */}
        <div
          className="prose prose-invert max-w-none text-base sm:text-lg leading-relaxed"
          dangerouslySetInnerHTML={{ __html: content }}
        />
      </div>
    </div>
  );
}

export default About;
